import { render, staticRenderFns } from "./RegisterStepCompany.vue?vue&type=template&id=fddd8e22&"
import script from "./RegisterStepCompany.vue?vue&type=script&lang=js&"
export * from "./RegisterStepCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports